export default {
  sitePage(siteId) {
    return `${process.env.ALIGNED_URL}/production/products/sites/${siteId}/edit`;
  },

  accommodationPage(accommodationId) {
    return `${process.env.ALIGNED_URL}/production/products/accommodations/${accommodationId}/edit`;
  },
};



// WEBPACK FOOTER //
// ./src/services/navigation-service.js